import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[scWidgetToggle]'
})
export class ScWidgetToggleDirective {
  /**
   * Constructor
   *
   * @param elementRef
   */
  constructor(public elementRef: ElementRef) {}
}
